import * as React from 'react'
import { Table } from 'react-bootstrap';


const OpeningHours = () => {

    return (

        <Table striped bordered className="text-center">
            <thead>
                <tr>
                    <th>Tag</th>
                    <th>Vormittag</th>
                    {/* <th>Pause</th> */}
                    <th>Nachmittag</th>
                </tr>
            </thead>
            <tbody>
                <tr >
                    <td>Montag</td>
                    <td>09:00 - 13:00 </td>
                    {/* <td>13:00 - 14:00 </td> */}
                    <td>14:00 - 18:00 </td>
                </tr>

                <tr>
                    <td>Dienstag</td>
                    <td>09:00 - 13:00 </td>
                    {/* <td>13:00 - 14:00 </td> */}
                    <td>14:00 - 18:00 </td>
                </tr>

                <tr>
                    <td>Mittwoch</td>
                    <td>09:00 - 13:00 </td>
                    {/* <td>13:00 - 14:00 </td> */}
                    <td>14:00 - 18:00 </td>
                </tr>

                <tr>
                    <td>Donnerstag</td>
                    <td>09:00 - 13:00 </td>
                    {/* <td>13:00 - 14:00 </td> */}
                    <td>14:00 - 18:00 </td>
                </tr>

                <tr>
                    <td>Freitag</td>
                    <td>09:00 - 13:00 </td>
                    {/* <td>13:00 - 14:00 </td> */}
                    <td>14:00 - 18:00 </td>
                </tr>

                <tr>
                    <td>Samstag</td>
                    <td>09:00 - 13:00 </td>
                    <td colSpan={2} className='text-center openingHoursClosed'>geschlossen</td>
                </tr>

                <tr>
                    <td>Sonntag</td>
                    <td colSpan={3} className='text-center openingHoursClosed' >geschlossen</td>
                </tr>

                <tr>
                    <td colSpan={4} className='text-center tableHint' ><b>Sowie Termine nach Vereinbarung</b></td>
                </tr>


            </tbody>

            <tbody className='openingHoursSpecial'>

                <br></br>

                <tr>
                    <td colSpan={4} className='text-center openingHoursSpecialHeader' ><h4>Sonderöffnungszeiten</h4></td>
                </tr>

                <tr>
                    <td colSpan={4} className='text-center tableHint' ><b>Am 8. und 31.12. geschlossen</b></td>
                </tr>

                <tr>
                    <td colSpan={4} className='text-center tableHint' ><b>Am 24. und 31.12. von 9 - 13 Uhr geöffnet</b></td>
                </tr>

            </tbody>

        </Table>

        

    )

}

export default OpeningHours